module.exports = __webpack_public_path__ + "img/tavakademi-mobil.44483417.jpg";